import { component } from 'picoapp'
import $ from '../lib/quantdom'

export default component((node) => {
  var debounceTimeout

  //scroll track scrolled
  $(node)
    .find('[data-scroll-track]')
    .on('scroll', (e) => {
      clearTimeout(debounceTimeout)
      debounceTimeout = setTimeout(function () {
        updateArrowsFromScrollPosition(e.target.scrollLeft)
      }, 100)
    })

  //arrow left clicked
  $(node)
    .find('.js-arrow-left')
    .on('click', () => {
      scrollByClick('left')
    })

  //arrow right clicked
  $(node)
    .find('.js-arrow-right')
    .on('click', () => {
      scrollByClick('right')
    })

  const getPosition = (el) => {
    return parseInt($(el).attr('data-scroll-position'))
  }

  const setPosition = (el, position) => {
    $(el).attr('data-scroll-position', position)
  }

  const updateArrowsFromScrollPosition = (pos) => {
    const scrollTrackEl = $(node).find('[data-scroll-track]').el()
    const scrollWidth = scrollTrackEl.scrollWidth
    const slideWidth = scrollTrackEl.offsetWidth
    const arrowLeft = $(node).find('.js-arrow-left').el()
    const arrowRight = $(node).find('.js-arrow-right').el()

    if (pos > 0) {
      arrowLeft.removeAttribute('disabled')
    } else {
      arrowLeft.disabled = true
    }
    if (pos < scrollWidth - slideWidth) {
      arrowRight.removeAttribute('disabled')
    } else {
      arrowRight.disabled = true
    }

    setPosition(scrollTrackEl, Math.round(pos / slideWidth) + 1)
  }

  const scrollByClick = (direction) => {
    const scrollTrackEl = $(node).find('[data-scroll-track]').el()
    const slideWidth = scrollTrackEl.offsetWidth
    const position = getPosition($('[data-scroll-track]').el())
    const scrollToIndex = direction == 'right' ? position + 1 : position - 1
    const scrollToPx = scrollToIndex == 1 ? 0 : scrollToIndex * slideWidth - slideWidth / 2 - 1

    setPosition(scrollTrackEl, scrollToIndex)

    //Scroll to
    scrollTrackEl.scrollLeft = scrollToPx
  }
})
